import React from 'react';

function Card({ children, className = '', style = {}, hasBorder = true, hasShadow = true }) {
    return (
        <div className={`w-auto ${hasBorder ? 'border' : ''} ${hasShadow?'shadow-lg':''} ${className}`} style={style}>
            { children}
        </div>
    );
}

export default Card;
